import React, { useState } from "react";
import { Modal, Button, Col, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { GraphUser } from "../../../../graphql/types";
import { useUserBlockMutation } from "../../../graphql/menu.hooks";
import { DeepPartial } from "../../../types";

type Props = {
  showModal: boolean;
  handleCloseModal: () => void;
  selectedUser: DeepPartial<GraphUser>;
  refetch: () => void;
};

export const BlockUserModal = ({
  showModal,
  handleCloseModal,
  selectedUser,
  refetch,
}: Props) => {
  const { t } = useTranslation();
  const [comment, setComment] = useState<string>("");

  const [blockUser, { loading }] = useUserBlockMutation();

  const tryBlockUser = async () => {
    try {
      const { data } = await blockUser({
        variables: { userId: selectedUser?.id, status: true, comment },
      });

      if (data?.userBlock) {
        refetch();
        handleCloseModal();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={handleCloseModal}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="fs-3">Block User</Modal.Title>
      </Modal.Header>
      <div className="blockModal">
        <div className="px-3">
          <div className="form-floating mb-3">
            <textarea
              className="form-control"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Leave a comment here"
              id="floatingTextarea"
              style={{ height: "100px", resize: "none" }}
            ></textarea>
            <label
              className="fs-6 text-gray fw-normal"
              htmlFor="floatingTextarea"
            >
              Reason for Blocking
            </label>
          </div>
        </div>

        <div className="modalMobileBtns d-flex align-items-center justify-content-between gx-md-2">
          <Col className="modalMobileBtn" md={5}>
            <Button
              variant="outline-danger"
              className="w-100 h-100 danger-hover fw-normal fs-6"
              onClick={tryBlockUser}
              disabled={loading}
            >
              Block
              {loading && (
                <Spinner animation="border" role="status" className="ms-2">
                  <span className="visually-hidden">
                    {t("profile.loading")}...
                  </span>
                </Spinner>
              )}
            </Button>
          </Col>
          <Col className="modalMobileBtn" md={5}>
            <Button
              variant="primary"
              onClick={() => {
                handleCloseModal();
              }}
              className="w-100 h-100 text-white primary-hover fs-6"
            >
              Close
            </Button>
          </Col>
        </div>
      </div>
    </Modal>
  );
};
